@import '~style-sheet-helpers/core.less';
@import '../../../../../app-brand/entities/entity-layer.module.less';
@import (reference) '../../../../../constants/spacing.module.less';

.add-ons-card {
  gap: 6px;
  padding-top: @space-8;
  display: grid;
  * > {
    justify-self: center;
  }
}

.add-ons-description {
  text-align: center;
}

.empty-box {
  height: 63px;
}

.add-ons-marketplace-link-empty-state {
  display: flex;
}

.add-ons-marketplace-link {
  display: flex;
  padding-left: @space-4;
}

.right-arrow {
  height: 16px;
  padding-left: @space-4;
}

.right-arrow-empty-state {
  height: 16px;
  padding-left: @space-8;
}

.add-ons-row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-left: @space-4;

  &:hover {
    background-color: var(--grey-100);
  }

  .add-ons-name-row {
    align-items: baseline;
  }

  .add-ons-name {
    padding-right: @space-8;
  }
}

.premium-features-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.actions {
  font-size: 12px;
  text-align: right;
}

.premium-features-description {
  margin-bottom: @space-16;
  color: var(--grey-600);
  display: flex;
}

.feature-table {
  display: grid;
  gap: @space-4;
}
